// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2njko","label":"Radio_label__3yqnv","checkMark":"Radio_checkMark__1CLzZ","disabled":"Radio_disabled__1d9yR"};